import { render, staticRenderFns } from "./FormDetails.vue?vue&type=template&id=9ae3af6e&scoped=true"
import script from "./FormDetails.vue?vue&type=script&lang=js"
export * from "./FormDetails.vue?vue&type=script&lang=js"
import style0 from "./FormDetails.vue?vue&type=style&index=0&id=9ae3af6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae3af6e",
  null
  
)

export default component.exports